import { CSSProperties, PropsWithChildren } from 'react';
import clsx from 'clsx';

import styles from './Box.module.css';

interface BoxProps extends PropsWithChildren {
  display?: CSSProperties['display'];
  borderRadius?: CSSProperties['borderRadius'];
  padding?: CSSProperties['padding'];
  paddingTop?: CSSProperties['paddingTop'];
  paddingBottom?: CSSProperties['paddingBottom'];
  paddingLeft?: CSSProperties['paddingLeft'];
  paddingRight?: CSSProperties['paddingRight'];
  justifyContent?: CSSProperties['justifyContent'];
  alignItems?: CSSProperties['alignItems'];
  flexDirection?: CSSProperties['flexDirection'];
  flexWrap?: CSSProperties['flexWrap'];
  gap?: number;
  paddingX?: number;
  paddingY?: number;

  className?: string;
}

export const Box = ({
  children,
  className,
  display,
  borderRadius,
  padding,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  justifyContent,
  alignItems,
  flexDirection = 'row',
  paddingX,
  paddingY,
  gap,
  flexWrap,
}: BoxProps) => {
  return (
    <div
      className={clsx(styles.box, className, {
        [styles.paddingX]: !!paddingX,
        [styles.paddingY]: !!paddingY,
        [styles['padding-bottom']]: !!paddingBottom,
        [styles['padding-left']]: !!paddingLeft,
        [styles['padding-right']]: !!paddingRight,
        [styles['padding-top']]: !!paddingTop,
      })}
      style={
        {
          '--display': display,
          '--border-radius': `${borderRadius}px`,
          '--padding': `${padding}px`,
          '--padding-top': `${paddingTop}px`,
          '--padding-bottom': `${paddingBottom}px`,
          '--padding-left': `${paddingLeft}px`,
          '--padding-right': `${paddingRight}px`,
          '--justify-content': justifyContent,
          '--align-items': alignItems,
          '--flex-direction': flexDirection,
          '--padding-x': `${paddingX}px`,
          '--padding-y': `${paddingY}px`,
          '--gap': `${gap}px`,
          '--flex-wrap': flexWrap,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};
